import { ICategoryPageMatch } from "@faire/retailer-shared/categories/ICategoryPageMatch";
import {
  BRAND_VALUE_FILTER_TYPE,
  buildFilterKey,
} from "@faire/retailer-shared/filters/filterKeys";
import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";

import { useCategoryPageQueryParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";

/**
 * This parses the filter keys based on the filters query param from URL,
 * then some ad-hoc logic injects additional filter keys into the list,
 * and returns the final filter keys in sorted order.
 */
export const useCategoryPageFilterKeys = (): string[] => {
  const { filterKeys } = useCategoryPageQueryParams();

  const match = useRouteMatch<ICategoryPageMatch>();

  return useMemo(() => {
    // We support the URL suffix /brandValue/:brandValue for SEO purpose
    // this value should be treated as an initial value for filters and the
    // "filters" property from query parameter takes precedence
    //
    // Also we prefer dash to underscore in URL, so need to do a conversion before
    // using the value
    const matchedFilterByBrandValue = match.params.brandValue?.replace(
      /-/g,
      "_"
    );

    if (matchedFilterByBrandValue) {
      const brandValueFilterKey = buildFilterKey(
        BRAND_VALUE_FILTER_TYPE,
        matchedFilterByBrandValue
      );
      if (!filterKeys.includes(brandValueFilterKey)) {
        filterKeys.push(brandValueFilterKey);
      }
    }
    return filterKeys;
  }, [filterKeys, match.params.brandValue]);
};
